import { Vue, Component } from 'vue-property-decorator';

@Component
export default class legacyMixin extends Vue {
  get isLegacyFeatures(): boolean {
    const legacyQuery = this.$route.query.legacy as string;
    return legacyQuery === 'true';
  }
}
